// extracted by mini-css-extract-plugin
module.exports = {"tabSet":"TabSet_tabSet__2tgL3","divider":"TabSet_divider__2H4Rv","frame":"TabSet_frame__fX9d3","content":"TabSet_content__Q0qZ1"};